import { commonStyle } from './commonStyle'

const addClasses = (...classes) => classes.join(' ')

export {
  commonStyle,
  addClasses
}
